<!--
    Page: Renewal Renew Policy
    Author: Pooja & sunny 
	Date: 01-09-2020
-->

<div class="container-fluid mob-pad-l-r-0 tab-pad-l-r-0 parent-div">
    <div class="row mob-pad-l-r-0 tab-pad-l-r-0 ">
        <div class="col-lg-6 col-md-5 col-sm-5 d-none d-sm-block">
            <img class="download-img-width new-illustration" src="assets/images/new-renew/renew-illustration-abc.svg">
            <div class="renew-policy-bg">
                <div class="renew-your-policy-txt">Renew your Policy</div>
            </div>
        </div>
        <div class="col-lg-6 col-md-7 col-sm-7 col-xs-12 mob-pad-l-r-0 tab-pad-l-r-0 form-page renewal-login">
            <!-- <div class="d-none d-sm-block help-us-header-txt">Help us find your policy by <span class="any-two-red-clr">entering ANY 2</span> from the below</div> -->
            <div class="d-none d-sm-block help-us-header-txt">Help us find your policy</div>
            <div class="d-lg-none d-md-none d-sm-none col-xs-12 mob-white-bg">
                <div class="mob-renew-policy-txt">Renew your Policy</div>
                <div class="help-us-header-txt">Help us find your policy</div>
                <!-- <div class="help-us-header-txt">Help us find your policy by <span class="any-two-red-clr">entering ANY 2</span> from the below</div> -->
            </div>

            <form form [formGroup]="form"
                (ngSubmit)="this.appservice.submitEvent('group-renewal-login','click','login-click') ;  GenrateOTP(auth,form,false)">
                <div>
                    <div class="row text-right lbl-pad-btm justify-content-end  mr-0 ml-0">
                        <div class="col-lg-12 col-md-12 pad-l-r-0">
                            <label class="lbl-txt">Your COI Number <span class="any-two-red-clr">*</span></label>
                        </div>
                        <div class="col-lg-9 col-md-9 pad-l-r-0 pull-right">
                            <input type="text" class="form-control textbox-style phone-group"
                                style="text-transform: uppercase;" [(ngModel)]="auth.policynumber" id="policynum"
                                policyNumberOnly formControlName="policyNo" minlength="16" maxlength="25"
                                placeholder="G0-00-0000000-00" [attr.disabled]="downloadCOI? true : null" required>
                        </div>
                    </div>

                    <div class="row text-right justify-content-end mr-0 ml-0">
                        <div class="col-lg-12 col-md-12 pad-l-r-0">
                            <label class="lbl-txt">Proposer’s Mobile Number</label>
                        </div>
                        <div class="col-lg-9 col-md-9 pad-l-r-0 pull-right">
                            <input class="form-control textbox-style phone-group" type="text"
                                placeholder="Mobile Number" formControlName="txtMobileNumber"
                                [(ngModel)]="auth.txtMobileNumber" id="txtMobileNumber" minlength="10" appNumberOnly
                                maxlength="10" [attr.disabled]="downloadCOI ? true : null" required>
                        </div>
                    </div>
                    <div class="row text-right justify-content-end" [hidden]="editCOIMobile">
                        <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 text-right proceed-btn-pad-btm">
                            <a href="javascript:void(0);">
                                <button type="button" (click)="EditCOIMobile()" class="btn editCOIMobile-btn">Edit COI
                                    Number / Mobile Number</button>
                            </a>
                        </div>
                    </div>

                    <div class="row text-right lbl-pad-btm justify-content-end mr-0 ml-0" [hidden]="genrateOtp">
                        <div class="vil-form-otp">
                            <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 text-right lbl-pad-btm pr-0">
                                <div class="col-lg-12 col-md-12 pad-l-r-0">
                                    <label class="lbl-txt">Enter the OTP you received <span
                                            class="any-two-red-clr">*</span></label>
                                </div>
                                <div class="col-lg-12 col-md-12 pad-l-r-0 pull-right">
                                    <input autocomplete="nope" type="tel" class="form-control textbox-style phone-group"
                                        formControlName="otpvalue" id="otp" [(ngModel)]="auth.otpvalue" name="otpvalue"
                                        minlength="4" maxlength="6" placeholder="Eg. 123456">
                                    <label style="color: brown ; padding-top: 5px;">{{OTPText}}</label>
                                </div>
                            </div>
                            <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 text-right lbl-pad-btm pr-0">
                                <a href="javascript:void(0);">
                                    <button type="button" class="btn resend-opt-btn"
                                        (click)="GenrateOTP(auth,form,true )">Resend OTP</button>
                                </a>
                                <a href="javascript:void(0);">
                                    <button type="button" class="btn verify-otp-btn"
                                        (click)="verifyOTP(auth.otpvalue)">Verify OTP</button>
                                </a>
                            </div>
                        </div>
                    </div>
                    <div class="row text-right lbl-pad-btm justify-content-end" [hidden]="downloadCOI">
                        <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 text-right proceed-btn-pad-btm">
                            <a href="javascript:void(0);">
                                <button type="submit" [disabled]="!auth.policynumber" class="btn proceed-btn">Send
                                    OTP</button>
                            </a>
                        </div>
                    </div>
                </div>
            </form>

        </div>
    </div>
</div>

<app-alert-swipe></app-alert-swipe>